import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { map, take } from 'rxjs';

/**
 * Guard that redirects to the appropriate dashboard based on user role
 * - SUPER_ADMIN users go to /dashboard (global view)
 * - Store admins go to /store-dashboard (single store view)
 */
export const DashboardRedirectGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const userService = inject(UserService);

    return userService.user$.pipe(
        take(1),
        map(user => {
            if (user?.is_super_admin) {
                // SUPER_ADMIN goes to global dashboard
                router.navigate(['/dashboard']);
            } else {
                // Store admin goes to store-specific dashboard
                router.navigate(['/store-dashboard']);
            }
            return false; // Prevent activating the redirect route itself
        })
    );
};
